var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgL2DoiGplx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    transform: "translate(0.199951)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.7295 5.10706H7.6794C5.54288 5.10706 3.81091 6.82775 3.81091 8.9504V25.8263C3.81091 27.9491 5.54288 29.6698 7.6794 29.6698H31.7295C33.866 29.6698 35.598 27.9491 35.598 25.8263V8.9504C35.598 6.82775 33.866 5.10706 31.7295 5.10706Z",
    fill: "#EBEDF2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9432 15.933C14.3879 15.933 15.5591 14.7693 15.5591 13.334C15.5591 11.8987 14.3879 10.7351 12.9432 10.7351C11.4985 10.7351 10.3273 11.8987 10.3273 13.334C10.3273 14.7693 11.4985 15.933 12.9432 15.933Z",
    fill: "url(#paint0_linear_1372_1641)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9432 17.3445C10.1844 17.3445 7.94788 19.5664 7.94788 22.3073C7.94788 22.6989 8.26734 23.0163 8.66135 23.0163H17.2248C17.619 23.0163 17.9384 22.6989 17.9384 22.3073C17.9386 19.5664 15.702 17.3445 12.9432 17.3445Z",
    fill: "url(#paint1_linear_1372_1641)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3001 13.4931H21.4704C20.7098 13.4931 20.0933 12.8806 20.0933 12.125C20.0933 11.3693 20.7098 10.7568 21.4704 10.7568H30.3001C31.0607 10.7568 31.6781 11.3693 31.6781 12.125C31.6781 12.8806 31.0607 13.4931 30.3001 13.4931Z",
    fill: "url(#paint2_linear_1372_1641)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3001 18.3632H21.4704C20.7098 18.3632 20.0933 17.7508 20.0933 16.9951C20.0933 16.2394 20.7098 15.627 21.4704 15.627H30.3001C31.0607 15.627 31.6781 16.2394 31.6781 16.9951C31.6781 17.7508 31.0607 18.3632 30.3001 18.3632Z",
    fill: "url(#paint3_linear_1372_1641)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0475 23.0246L21.4704 23.0246C20.7098 23.0246 20.0933 22.4121 20.0933 21.6565C20.0933 20.9008 20.7098 20.2883 21.4704 20.2883L25.0475 20.2883C25.808 20.2883 26.4254 20.9008 26.4254 21.6565C26.4254 22.4121 25.808 23.0246 25.0475 23.0246Z",
    fill: "url(#paint4_linear_1372_1641)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.589 28.4776C36.589 32.0207 33.7167 34.893 30.1736 34.893C26.6304 34.893 23.7581 32.0207 23.7581 28.4776C23.7581 24.9344 26.6304 22.0621 30.1736 22.0621C33.7167 22.0621 36.589 24.9344 36.589 28.4776Z",
    fill: "#0068FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7816 27.6266C27.0731 26.0108 28.4962 24.7887 30.2016 24.7887C31.2136 24.7887 32.1259 25.2191 32.7608 25.9054C32.9412 26.1005 32.9294 26.4049 32.7343 26.5854C32.5392 26.7658 32.2348 26.754 32.0544 26.5589C31.5949 26.0622 30.9356 25.751 30.2016 25.751C29.0224 25.751 28.0371 26.5543 27.7643 27.6341L27.9159 27.4887C28.1078 27.3048 28.4123 27.3112 28.5962 27.503C28.7802 27.6948 28.7737 27.9994 28.5819 28.1833L27.5411 29.1813C27.4466 29.2719 27.3192 29.3201 27.1884 29.3147C27.0576 29.3094 26.9346 29.251 26.8479 29.153L25.9641 28.155C25.7879 27.9561 25.8064 27.652 26.0053 27.4758C26.2042 27.2996 26.5083 27.3181 26.6845 27.517L26.7816 27.6266Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1558 27.6404C33.2865 27.6456 33.4095 27.7038 33.4964 27.8016L34.3826 28.799C34.559 28.9977 34.5411 29.3018 34.3424 29.4783C34.1438 29.6548 33.8396 29.6368 33.6631 29.4381L33.5635 29.326C33.2719 30.9442 31.8423 32.1665 30.1318 32.1665C29.1237 32.1665 28.2139 31.7422 27.5773 31.0639C27.3955 30.8701 27.4051 30.5656 27.5989 30.3837C27.7927 30.2019 28.0972 30.2115 28.279 30.4053C28.74 30.8965 29.3986 31.2041 30.1318 31.2041C31.3167 31.2041 32.3048 30.4011 32.5795 29.3234L32.4315 29.4656C32.2398 29.6497 31.9353 29.6435 31.7512 29.4519C31.5671 29.2602 31.5733 28.9556 31.7649 28.7715L32.8034 27.7741C32.8978 27.6835 33.025 27.6352 33.1558 27.6404Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1372_1641",
    x1: 10.3273,
    y1: 13.3341,
    x2: 15.5591,
    y2: 13.3341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF97A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9374C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1372_1641",
    x1: 7.94759,
    y1: 20.1799,
    x2: 17.9388,
    y2: 20.1799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF97A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9374C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1372_1641",
    x1: 20.0931,
    y1: 12.1248,
    x2: 31.6781,
    y2: 12.1248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F6C7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A465B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1372_1641",
    x1: 20.0931,
    y1: 16.9954,
    x2: 31.6781,
    y2: 16.9954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F6C7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A465B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1372_1641",
    x1: 20.0931,
    y1: 21.6566,
    x2: 31.6781,
    y2: 21.6566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F6C7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A465B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgL2DoiGplx);
export default __webpack_public_path__ + "static/media/L2doiGPLX.1779fa1b7a835990d56ea7389af43465.svg";
export { ForwardRef as ReactComponent };